/**
 *
 * Asynchronously loads the component for API Keys
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ApiKeys = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.ApiKeys,
);
